import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import {
  GetProfileSeriesDto,
  GetScenarioProfilesDto,
  ProfileClient,
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { GetCacheOpts } from '@common-modules/cache/http-cache/http-cache.client';
import { Observable } from 'rxjs';

@Injectable()
export class ProfilesService extends GeneratedClientManagerService {
  expiration: GetCacheOpts = { expiration: 'default', reload: true };

  private _profilesClient: ProfileClient;
  constructor() {
    super();

    this._profilesClient = new ProfileClient(this.httpClient, this.baseUrl);
  }

  getScenarioProfiles(scenarioIds: string[]): Observable<GetScenarioProfilesDto> {
    const context = this.buildHttpContext();
    return this._profilesClient.getScenarioProfiles(scenarioIds, context);
  }

  getScenarioProfileSeries(profileId: string, date: Date): Observable<GetProfileSeriesDto> {
    const context = this.buildHttpContext();
    return this._profilesClient.getProfileSerie(profileId, date, context);
  }
}
